/* eslint-disable react/require-default-props */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classnames from 'classnames';
import FontAwesome from 'react-fontawesome';
import { showUploadProfilePhotoModal } from '../../../../components/UploadProfilePhotoModal/loadable';

import { makeMetricsLogEvent } from '../../../../../ReduxStorage/Metrics/manualEventDispatchers';

class _ProfileHeaderAvatar extends PureComponent {
  static propTypes = {
    user: ImmutablePropTypes.map,
    hasEditAccess: PropTypes.bool,
    metricsLogEvent: PropTypes.func.isRequired,
  };

  onOpenChangeProfilePicture = () => {
    const { metricsLogEvent } = this.props;
    showUploadProfilePhotoModal();

    // Technically not changed, just clicked
    metricsLogEvent('ProfileChanged', {
      itemChanged: 'image',
    });
  };

  render() {
    const { user, hasEditAccess } = this.props;

    if (hasEditAccess && user.get('avatar@3x')) {
      return (
        <button
          type="button"
          className="header-avatar"
          onClick={this.onOpenChangeProfilePicture}
        >
          <img
            className="header-avatar-img"
            src={user.get('avatar@3x')}
            alt={user.get('fullName')}
          />
          <span className="header-avatar-overlay">
            <FontAwesome className="header-avatar-fa" name="edit" /> Change
            picture
          </span>
        </button>
      );
    } else {
      return (
        <div
          className={classnames('header-avatar', {
            'skeleton-loading': !user.get('avatar@3x'),
          })}
        >
          <img
            className="header-avatar-img"
            src={user.get('avatar@3x')}
            alt={user.get('fullName')}
          />
        </div>
      );
    }
  }
}

export const ProfileHeaderAvatar = connect(undefined, {
  metricsLogEvent: makeMetricsLogEvent,
})(_ProfileHeaderAvatar);
